var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTandc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 48,
    viewBox: "0 0 39 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4899 44.5201H3.25757V7.601H13.0303V9.77271H21.7171V7.601C21.7171 7.601 26.1607 7.601 29.0079 7.601C32.7619 6.48412 34.7474 7.601 34.7474 7.601V4.29999H21.7171C21.6846 1.92197 19.7517 0 17.3737 0C14.9957 0 13.0629 1.92197 13.0303 4.29999H0V47.7777H34.7474V29.2887L31.4899 29.1335V44.5201ZM9.77271 24.9747H14.1161V20.6313H18.4596V16.2879H14.1161V11.9444H9.77271V16.2879H5.42928V20.6313H9.77271V24.9747ZM7.601 35.8333H5.42928V38.005H7.601V35.8333ZM29.3181 35.8333H9.77271V38.005H29.3181V35.8333ZM7.601 31.4898H5.42928V33.6616H7.601V31.4898ZM29.3181 31.4898H9.77271V33.6616H29.3181V31.4898ZM5.42928 42.3484H7.601V40.1767H5.42928V42.3484ZM29.3181 40.1767H9.77271V42.3484H29.3181V40.1767Z",
    fill: "#0B5ED7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1176_1204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3452 15.6984V13.1389C36.3452 10.7841 34.4341 8.87302 32.0793 8.87302C29.7245 8.87302 27.8134 10.7841 27.8134 13.1389V15.6984H25.2539V27.6428H38.9047V15.6984H36.3452ZM32.9325 24.2301H31.2261V19.1111H32.9325V24.2301ZM34.6388 15.6984H29.5198V13.1389C29.5198 11.7311 30.6716 10.5794 32.0793 10.5794C33.487 10.5794 34.6388 11.7311 34.6388 13.1389V15.6984Z",
    fill: "#0B5ED7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1176_1204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.6508,
    height: 18.7698,
    fill: "white",
    transform: "translate(25.2539 8.873)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTandc);
export default __webpack_public_path__ + "static/media/tandc.c616fc60a382b2ccbbf439334b49921c.svg";
export { ForwardRef as ReactComponent };